import { useContextSelector } from "use-context-selector";
import { PrepareRecordingContext, PrepareRecordingContextType } from "./PrepareRecordingContext";

export function usePrepareRecording<T>(selector: (state: PrepareRecordingContextType) => T): T {
  return useContextSelector(PrepareRecordingContext, (context) => {
    if (!context) {
      throw new Error("This Hook must be used under PrepareRecordingProvider!");
    }

    return selector(context);
  });
}
